function eventHandler(event) {
  handler()
  document.removeEventListener('mousemove', arguments.callee);
  document.removeEventListener('scroll', arguments.callee);
  document.removeEventListener('touchstart', arguments.callee);
}

const move = document.addEventListener('mousemove', eventHandler);
const scroll = document.addEventListener('scroll', eventHandler);
const touch = document.addEventListener('touchstart', eventHandler);

async function handler() {
  console.log('load controller', window._lazyLoadAssets)
  if (!window._lazyLoadAssets) return
  for (let i = 0; i < window._lazyLoadAssets.length; i++) {
    let data = window._lazyLoadAssets[i]
    if (!data.src && !data.body) continue
    var tag
    if (data.type !== 'style') {
      tag = document.createElement('script');
      if (data.src) {
        if (checkScriptExists(data.src)) {
          console.log('скрипт уже загружен', data)
          continue
        }
        tag.src = data.src;
        tag.defer = true;
      } else if (data.body) {
        if (checkScriptContent(data.body)) {
          console.log('скрипт уже загружен', data)
          continue
        }
        console.log('load', data)
        tag.type = 'text/javascript';
        tag.textContent = data.body;
      }
    } else {
      tag = document.createElement('link');
      if (data.src) {
        if (checkCSSExists(data.src)) {
          console.log('стиль уже загружен', data)
          continue
        }
        tag.rel = 'stylesheet';
        tag.href = data.src;
        tag.media = 'all';
      }
    }
    // Обработчик загрузки (опционально)
    tag.onload = function () {
      console.log(`${tag.src} успешно загружен`);
    };
    // Обработчик ошибки загрузки (опционально)
    tag.onerror = function () {
      console.error(`Ошибка при загрузке ${tag.src}`);
    };
    console.log(tag)
    await asyncTimeout(() => {
      // Добавляем скрипт в конец тела документа
      document.body.appendChild(tag)
    }, 0)
  }
}

function checkScriptExists(src) {
  const script = document.querySelector(`script[src="${src}"]`);
  return script !== null;
}

function checkScriptContent(content) {
  const scripts = document.getElementsByTagName('script');
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].textContent.includes(content)) {
      return true;
    }
  }
  return false;
}

function checkCSSExists(href) {
  const style = document.querySelector(`link[href="${href}"]`);
  return style !== null;
}

async function asyncTimeout(func, delay) {
  return await new Promise((res) => {
    setTimeout(() => {
      func();
      res(true);
    }, delay)
  })
}